import "./es.array.is-array-7a29277f.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.to-string-f55666a8.js";
import a from "react";
var e = function(i) {
  return !!(i && typeof i == "object" && !Array.isArray(i));
}, y = function(i, r, f) {
  var u;
  if (f === void 0 && (f = 0), !i || !r)
    return i;
  if (Array.isArray(i))
    return i.map(function(t, m) {
      var c;
      return y(t, Array.isArray(r) ? (c = r.find(function(A) {
        return (t == null ? void 0 : t.type) === A[0];
      })) == null ? void 0 : c[1] : r, m);
    });
  if (Array.isArray(r))
    return y(i, (u = r.find(function(t) {
      return i.type === t[0];
    })) == null ? void 0 : u[1]);
  if (typeof r == "function") {
    var n = r(i.props, f);
    return /* @__PURE__ */ a.isValidElement(n) ? n : e(n) ? /* @__PURE__ */ a.cloneElement(i, n) : n;
  }
  return /* @__PURE__ */ a.isValidElement(r) ? r : /* @__PURE__ */ a.cloneElement(i, r);
};
export {
  y as _,
  e as i
};
